import { ReactElement } from 'react';
import { LinkIcon, LinkMobileIcon, LinkText } from './LinkVariant.styles';
import { LinkVariantProps } from './LinkVariant.types';

export const LinkVariant = ({
  articleLink,
  linkAsIcon,
  hoverColor,
}: LinkVariantProps): ReactElement => {
  return !linkAsIcon ? (
    <>
      <LinkIcon />
      <LinkText>{articleLink}</LinkText>
    </>
  ) : (
    <LinkMobileIcon color={hoverColor} />
  );
};
